import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { ScheduleSelectorDialog } from "./schedule-selector-dialog"
import { updateProjectScopedSchedules } from "authoring/routes/project/controller/update-project-scoped-schedules"
import { useParams } from "react-router"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ResetTabledRepeat } from "event-definitions"

export function ScopedSchedulesButton({ variant = "contained" }) {
    const { projectId } = useParams()
    const [sentToLegacy] = useBoundValue("sentToLegacy")
    const [archived] = useBoundValue("archived")
    const { createdScheduleIds } = useBoundContext()

    const openDialog = useDialog(<ScheduleSelectorDialog />, { maxWidth: "md" })

    return (
        <Button
            data-cy="scoped-schedules-button"
            variant={variant}
            color="primary"
            onClick={handleClick}
            startIcon={<Iconify icon={"ic:round-add"} />}
            sx={{ mt: 2, mb: 3 }}
            disabled={!!sentToLegacy || !!archived}
        >
            Add Schedules
        </Button>
    )

    async function handleClick() {
        try {
            const selectedScheduleIds = await openDialog()
            if (!selectedScheduleIds) return
            const scopedScheduleIds = [...selectedScheduleIds, ...createdScheduleIds]
            const saved = await updateProjectScopedSchedules({ projectId, scopedScheduleIds })
            if (!saved) throw new Error()
            ResetTabledRepeat.raiseOnce()
            successSnackbar("Successfully saved selected schedules")
        } catch (error) {
            console.error(error)
            errorSnackbar("Failed to save select schedules")
        }
    }
}
